<template>
  <section class="form-list">
    <el-form
      class="form form-large"
      ref="form"
      :rules="rules"
      :model="courseVideo"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="视频名称" prop="course_video_name">
        <el-input
          v-model="courseVideo.course_video_name"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入视频名称"
        />
      </el-form-item>

      <v-image-upload
        v-model="courseVideo.cover"
        label="视频封面"
        prefix="course-video-cover"
        ratio="16:9"
        prop-name="cover"
      />

      <v-video-upload
        label="视频文件"
        prefix="course-introduction"
        prop-name="raw_src"
        v-model="courseVideo.raw_src"
        :src="courseVideo.src"
        :is-edit="true"
        @srcChange="src => courseVideo.src = src"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存修改</el-button>
        <el-button @click="RouteConfig.courseVideoList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/course-video';

export default {
  name: RouteConfig.courseVideoEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    courseVideo: {
      course_video_name: '',
      cover: '',
      raw_src: '',
      src: '',
      update_time: 0,
      state: 0,
    },
    rules: {
      course_video_name: [{ required: true, message: '请输入封面名称', trigger: 'change' }],
      cover: [{ required: true, message: '请上传视频封面', trigger: 'change' }],
      raw_src: [{ required: true, message: '请上传视频文件', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.courseVideo };
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseVideoList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { courseVideo } = this;
      const courseVideoInfo = {};
      Object.keys(data).forEach(key => {
        if (key in courseVideo) courseVideoInfo[key] = data[key];
      });
      Object.assign(courseVideo, courseVideoInfo);
    },
  },
};
</script>
